/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherUmbrellaIcon16Light = forwardRef('WeatherUmbrellaIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 1.25a.5.5 0 0 0-1 0v.769a6.501 6.501 0 0 0-5.994 6.21A.742.742 0 0 0 2.75 9H8v4a1 1 0 1 1-2 0v-.25a.5.5 0 0 0-1 0V13a2 2 0 1 0 4 0V9h5.25c.41 0 .763-.336.745-.77A6.501 6.501 0 0 0 9 2.018V1.25ZM3.023 8h10.955A5.5 5.5 0 0 0 3.023 8Z" })));
});
